import { Button, Flex, Stack, Text } from '@mantine/core';
import { useSuspenseQuery } from '@tanstack/react-query';
import { Outlet, createFileRoute } from '@tanstack/react-router';

import { getMinStdAnnexTemplateOptions, getMinStdOptions } from '@/module/MinimalStandard/model/MinStdQuery';

import { Content } from '@/core/components';

export const Route = createFileRoute('/_auth/minimal-standards/_layout/report/gather/_gather/$indicatorCode/_layout')({
  component: RouteComponent,
});

function RouteComponent() {
  const { indicatorCode } = Route.useParams();
  const { userId } = Route.useSearch();
  const { data: report } = useSuspenseQuery(getMinStdOptions(Number(userId)));
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const { data: template } = useSuspenseQuery(getMinStdAnnexTemplateOptions(report!.minStdAnnexNo!));
  const indicators = template.indicators;

  const index = indicators.map(c => c.indicatorCode).indexOf(indicatorCode);
  const indicator = indicators[index];

  const navigate = Route.useNavigate();
  const next = () =>
    navigate({
      to: `/minimal-standards/report/gather/$indicatorCode`,
      params: { indicatorCode: indicators[index + 1].indicatorCode },
      search: true,
    });

  const prev = () =>
    navigate({
      to: `/minimal-standards/report/gather/$indicatorCode`,
      params: { indicatorCode: indicators[index - 1].indicatorCode },
      search: true,
    });

  return (
    <Stack>
      <Content
        type="full"
        p="sm"
      >
        <Flex
          align="center"
          justify="space-between"
        >
          <Button
            miw="70px"
            size="xs"
            onClick={prev}
            disabled={index === 0}
          >
            Înapoi
          </Button>
          <Text px="7px">
            Indicator {indicator.formattedIndicatorCode} / {indicators[indicators.length - 1].formattedIndicatorCode}
          </Text>
          <Button
            miw="90px"
            size="xs"
            onClick={next}
            disabled={index == indicators.length - 1}
          >
            Următorul
          </Button>
        </Flex>
        <div>
          <Text
            px="7px"
            fw="500"
            size="md"
          >
            {indicator.formattedIndicatorCode} - {indicator.title}
          </Text>
          <Text
            px="7px"
            c="dimmed"
            fs="italic"
            size="sm"
          >
            {indicator.legend}
          </Text>
        </div>
      </Content>
      <Outlet />
    </Stack>
  );
}
